const getStatusColor = s => {
  if(s === '삭제') return 'danger'  // Red
  if(s === '도착') return 'primary' // Purple
  if(s === '대기') return 'warning' // Orange
  if(s === '운행') return 'success' // Green
  if(s === '회차') return 'dark'
}

export { getStatusColor }
